import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import classNames from 'classnames';
import { Links } from './Links';
import './emt-links.scss';

export const LinkSets = ({ sets }) => {

  return (
    <div className="emt-links-sets">
      {(sets || []).map((set, i) => {
        const setsClassNames = classNames(' emt-links-sets__set', {
          'emt-links-sets__set--no-break': set?.links?.length < 8
        });
        return (
          <div className={setsClassNames} key={`set_${set.category}_${i}`}>
            <h4 className="emt-links-sets__category">{set.category}</h4>
            <Links links={set.links || []} />
          </div>
        );
      })}
    </div>
  );
};

LinkSets.propTypes = {
  sets: arrayOf(shape({
    category: string,
    links: arrayOf(shape({
      url: string,
      keyword: string
    })),
  })).isRequired
};
